export default {
  GET_CONSERVATION_FEES(state, data) {
    state.conservation_fees = data.data
  },
  GET_ALL_CONSERVATION_FEES(state, data) {
    state.all_conservation_fees = data.data
  },
  UPDATE_CONSERVATION_FEES(state, data) {
    state.all_conservation_fees = data
  },
  GET_CONSERVATION_FEE(state, data) {
    state.conservation_fee = data.data
  },
  GET_DELETED_CONSERVATION_FEES(state, data) {
    state.deleted_conservation_fees = data.data
  },
  LOCAL_CONSERVATION(state, data) {
    state.all_conservation_fees = data
  },
  GET_ALL_SCHOOL_CONSERVATION_FEES(state, data) {
    state.all_school_conservation_fees = data.data
  },
  GET_FULL_CONSERVATION_FEES(state, data) {
    state.all_full_conservation_fees = data.data
  },
  UPDATE_ALL_CONSERVATION_FEES(state, data) {
    state.all_school_conservation_fees = data
  },
  GET_FULL_CONSERVATION_SCHEDULE(state, data) {
    state.all_conservation_fees_schedule = data.data
  },
  ADD_PROOF_RESIDENCY(state, data) {
    state.residency_proof.push(data);
  },
  ADD_PROOF_RESIDENCY_CHECKIN(state, data) {
    state.residency_proof_check_in.push(data);
  },
  CONSERVATION_FEES_PROOF(state, data) {
    state.conservation_fees_proof = data;
  },
  CONSERVATION_FEES_PROOF_CHECKIN(state, data) {
    state.conservation_fees_proof_checkin = data;
  },

  PROOF_RESIDENCY(state, data) {
    state.residency_proof = data
  },
  TO_PROOF_RESIDENCY(state, data) {
    state.to_proof_residency = data
  },
  PROOF_RESIDENCY_BOOKING_ID_UI(state, data) {
    state.residency_proof_booking_id = data
  },
  PROOF_RESIDENCY_BOOKING_ID(state, data) {
    state.residency_proof_booking_id = data.data
  },
  PROOF_RESIDENCY_CHECKIN(state, data) {
    state.residency_proof_check_in = data
  },
  REMOVE_PROOF_BOOKING_ID(state) {
    state.residency_proof_booking_id = [];
  },
  REMOVE_ALL_BOOKING_PROOFS(state) {
    state.conservation_fees_proof = [];
  },
  ALREADY_PROOFED_RESIDENCY(state, data) {
    state.proofed_residency = data;
  },

}
